import { SxProps, Theme } from '@mui/system';

const classes = {
  container: {
    width: '100%',
    marginBottom: 3,
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
